import { createIcon } from '../icon'
import ReclaimIcon from '../svg/ReclaimIcon'

export const ReclaimIconDefault = createIcon(ReclaimIcon)
